import { ThemeParameters } from '../types';

export type GraphToken = (theme: ThemeParameters) => string;

export const colorGraph1: GraphToken = (theme) => theme.colors.colorGraph1;
export const colorGraph2: GraphToken = (theme) => theme.colors.colorGraph2;
export const colorGraph3: GraphToken = (theme) => theme.colors.colorGraph3;
export const colorGraph4: GraphToken = (theme) => theme.colors.colorGraph4;
export const colorGraph5: GraphToken = (theme) => theme.colors.colorGraph5;
export const colorGraph6: GraphToken = (theme) => theme.colors.colorGraph6;
export const colorGraph7: GraphToken = (theme) => theme.colors.colorGraph7;
export const colorGraph8: GraphToken = (theme) => theme.colors.colorGraph8;
export const colorKPI1: GraphToken = (theme) => theme.colors.colorKPI1;
export const colorKPI3: GraphToken = (theme) => theme.colors.colorKPI3;
export const colorKPI5: GraphToken = (theme) => theme.colors.colorKPI5;

export default {
  colorGraph1,
  colorGraph2,
  colorGraph3,
  colorGraph4,
  colorGraph5,
  colorGraph6,
  colorGraph7,
  colorGraph8,
  colorKPI1,
  colorKPI3,
  colorKPI5,
};
